import { render, staticRenderFns } from "./ErpEntityMappingsPanel.vue?vue&type=template&id=48526a1d&scoped=true"
import script from "./ErpEntityMappingsPanel.vue?vue&type=script&lang=js"
export * from "./ErpEntityMappingsPanel.vue?vue&type=script&lang=js"
import style0 from "./ErpEntityMappingsPanel.vue?vue&type=style&index=0&id=48526a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48526a1d",
  null
  
)

export default component.exports